<!--  -->
<template>
  <div class="container">
    <div class="box">
      <img src="~@/assets/images/active/active20221115/1.png" alt="" />

      <div class="btn-box flex">
        <div class="btn share_bt">分享</div>
      </div>
    </div>

    <div class="v4">
      <img
        v-if="showDownLoad"
        src="~@/assets/images/ad/ad2/5.png"
        alt=""
        class="v4_1"
        @click="onDownload"
      />
    </div>
  </div>
</template>

<script>
import { h5 } from "@/utils/env";
import { initShare, getWXEvn, isBangBangApp, isWeixin } from "@/utils";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      initShareObg: {},
      showDownLoad: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (isWeixin()) {
      getWXEvn({
        //如果是小程序
        isMiniApp: () => {
          this.showDownLoad = false;
        },
        //如果是公众号网页
        isWeixinNotMiniApp: () => {},
      });
    } else if (isBangBangApp()) {
      this.showDownLoad = false;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initShareObg = new initShare({
      shareUrl: `${h5}app/v2/active/20221115-main.html`,
      sharePath: "commonh5",
      imgUrl: "https://static.shenzhoubb.com/images/miniapp/bianzu.png",
      miniAppImgUrl: "https://static.shenzhoubb.com/images/miniapp/share.png",
      title: "【最新招募，高薪寻找工程师】",
      desc: "我发现这里有个高薪机会，推荐给你，快来报名！",
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  //方法集合
  methods: {
    onDownload() {
      // location.href = `${h5}app/callApp.html`;
      location.href = `${h5}app/install.html?source=ENGINEER`;
    },
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.box {
  position: relative;
  box-sizing: border-box;
  width: 7.5rem;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-box {
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  padding-bottom: 0.37rem;

  .btn {
    width: 6.76rem;
    height: 0.9rem;
    margin: 0 auto;
    text-align: center;
    line-height: 0.9rem;
    font-size: 0.4rem;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: #fb4529;
    background: #ffd413;
    box-shadow: 0rem 0rem 0.3rem 0rem #fc8150;
    border-radius: 0.45rem;
  }
}
.v4 {
  position: absolute;
  top: 2rem;
  width: 1.01rem;
  right: 0;
  overflow: hidden;

  .v4_1,
  .share_bt {
    position: relative;
    width: 1.5rem;
    // right: -0.49rem;
  }
  .share_bt {
    margin-top: -0.55rem;
  }
}
</style>